module.exports = __webpack_public_path__ + "img/public.6a780077.svg";